module.exports = __webpack_public_path__ + "assets/img/memberdefault.5204dd2a.png";